import { fetchMetaTags } from '@/fetchers';

export default async ({
    id,
    fallback,
    mockQueries,
}) => {
    const data = await fetchMetaTags({ id, fallback }, mockQueries);

    return {
        // if altezza is sparse, fill in with fallback data.
        title: data?.title || fallback?.title,
        description: data?.description || fallback?.description,
        canonicalUrl: data?.canonicalUrl || fallback?.canonicalUrl,
        h1: data?.h1 || fallback?.h1,
        noIndex: data?.noIndex || fallback?.noIndex,
        ogImage: data?.ogImage || fallback?.ogImage,
        schemaOrg: data?.schemaOrg || null,
    };
};
